import { createContext } from 'react'

import { MessagesMessage } from 'primereact/messages'

export type InvoiceMessageContextType = {
  showMessage: (message: MessagesMessage | MessagesMessage[]) => void
  replaceMessage: (message: MessagesMessage | MessagesMessage[]) => void
  removeMessage: (message: MessagesMessage | MessagesMessage[]) => void
  clearMessages: () => void
}

const stub = (): never => {
  throw new Error(
    'You forgot to wrap your component in <InvoiceMessageContextProvider>',
  )
}

const initialValue: InvoiceMessageContextType = {
  clearMessages: stub,
  removeMessage: stub,
  replaceMessage: stub,
  showMessage: stub,
}

export const InvoiceMessageContext =
  createContext<InvoiceMessageContextType>(initialValue)
